import { Component, OnInit, AfterViewInit, ViewChild, ViewContainerRef, ComponentRef, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { formatMessage } from 'devextreme/localization';
import { Field } from 'devextreme/ui/pivot_grid/data_source';
import { PivotGridComponent } from '../../shared/components/pivot-grid/pivot-grid.component';
import { Report } from '../../shared/interfaces';
import { PivotGridConfig } from '../../shared/utils/pivot-grid-config';
import { DimensionService, LanguageService } from '../../shared/services';

@Component({
  selector: 'app-generated-report',
  templateUrl: './generated-report.component.html',
  styleUrls: ['./generated-report.component.scss'],
  standalone: false
})
export class GeneratedReportComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(PivotGridComponent, { static: true }) pivotGrid!: PivotGridComponent;
  // @ViewChild('pivotGridRef', { read: ViewContainerRef }) viewContainer!: ViewContainerRef;

  report!: Report;
  reportId!: Report;
  privotGridState: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private languageService: LanguageService,
    private dimensionService: DimensionService
  ) { }

  async ngOnInit(): Promise<void> {

    this.activatedRoute.data.subscribe(({ pivotGridConfig }) => {

      const {
        config: { options, showChart, filterYear, treeHeaderLayout },
        dimensions,
        parentDimensionrecords,
        report,
        reportId,
        distinctYears,
      } = pivotGridConfig;

      options.fields.forEach((field: Field) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        field.caption = formatMessage(field.caption!) || field.caption;
      });

      this.pivotGrid.options = options;
      this.pivotGrid.chartDefault = report.chart_default;
      this.pivotGrid.chartShow = report.chart_show; // !!showChart;
      this.pivotGrid.chartInverted = report.chart_inverted

      this.pivotGrid.dimensions = dimensions;
      // @TODO Remove
      // console.debug("[GeneretedReportComponet] Dimension reverse: ", dimensions)

      this.pivotGrid.distinctYears = distinctYears;
      this.pivotGrid.filterYear = filterYear;
      this.pivotGrid.treeHeaderLayout = treeHeaderLayout;
      this.pivotGrid.report = report;
      this.pivotGrid.reportId = reportId;
      this.report = report;
      this.reportId = reportId;

      this.pivotGrid.parentDimensionLabels = parentDimensionrecords.map((item: any) => { return item.label });
      
      // @TODO Remove
      // console.debug("[GeneretedReportComponet] ParentDimensionLabels: ", this.pivotGrid.parentDimensionLabels)
    });
  }

  ngAfterViewInit(): void {
    this.privotGridState = this.pivotGrid.pivotGridDataSource.state();
    // console.log('I am initiated!')    
  }

  ngOnDestroy() {
    this.pivotGrid.pivotGridDataSource.state(this.privotGridState);
    // console.log('I am destroyed!')  
  }

}
